export const selectScoreboard = (state) => {
  return state.scoreboardPage.scoreboards;
};
